import { Templates } from '../compile';

export const DefaultListPropertyTemplateMapping = {
	//[PropertyType.BOOLEAN]: Templates.list_cell_boolean,
	//[PropertyType.DATE]: Templates.list_cell_span,
	//[PropertyType.EMAIL]: Templates.list_cell_span,
	//[PropertyType.IMAGE]: Templates.list_cell_span,
	//[PropertyType.NUMBER]: Templates.list_cell_span,
	//[PropertyType.STRING]: Templates.list_cell_span,
	//[PropertyType.ENUM]: Templates.list_cell_enum_span

	// Fix for "A computed property name in a type literal must directly refer to a built-in symbol." in definition file --> ideas?

	0: Templates.list_cell_boolean,
	1: Templates.list_cell_span,
	2: Templates.list_cell_span,
	3: Templates.list_cell_span,
	4: Templates.list_cell_span,
	5: Templates.list_cell_span,
	6: Templates.list_cell_enum_span,
	7: Templates.list_cell_color
};
